module.exports = __webpack_public_path__ + "assets/img/5.14555ec8.svg";